query GetFundRecordTypes {
  fundRecordTypes {
    id
    name
    description
    salesforceId
  }
}
